import { render, staticRenderFns } from "./ModuleAttachment.vue?vue&type=template&id=21970f74"
import script from "./ModuleAttachment.vue?vue&type=script&lang=js"
export * from "./ModuleAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports